module.exports = __webpack_public_path__ + "static/media/SUPERFLO.75a37d38.jpg";